import React from 'react';
import { connect } from 'react-redux';
import { processType } from 'constants/process-type';
import { validatable } from 'components/utils';
import { GiaiQuyetDonThu } from 'api';
import { msg } from "constants/message";

const process = [processType.xuLyDon.processing.lanhDaoThuHoi, processType.xuLyDon.processing.truongPhongThuHoi];

class ThuHoiGQ extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_ThuHoi: false,

      donId: this.props.donId,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      content: this.props.content
    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {

      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {
          case processType.xuLyDon.processing.truongPhongThuHoi:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_ThuHoi: true
            });
          break;
          case processType.xuLyDon.processing.lanhDaoThuHoi:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_ThuHoi: true
            });
          break;
          default: break;
        }
      }
    });
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {

    GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(res => {
      if (res.data) {
        let info = res.data;

        this.setState({
          dataGiaiQuyetDon: info,
          nextState: info.nextStateInfo ? info.nextStateInfo.type : '',
          phongBanGiaiQuyet: info.nextStateInfo && info.phongBanGiaiQuyetInfo ? info.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
          truongPhongChiDinh: info.nextStateInfo && info.nextStateInfo.type === 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
          canBoChiDinh: info.nextStateInfo && info.nextStateInfo.type === 'LANH_DAO_GIAO_VIEC_CAN_BO' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
          noiDung: info.yKienGiaiQuyet ? info.yKienGiaiQuyet : '',
        });
      }
    }).then(() => {
      this.onlyOneState()
    });
  }

  onlyOneState() {

    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState));
    } else {
      this.trigger(this.state);
    }
  }

  handleChange(name, e) {

    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    if (name === 'nextState') {



      if (this.state.donId == 0) {
        newState = {
          ...newState,
          phongBanGiaiQuyet: '',
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        }
      }

    } else if (name === 'phongBanGiaiQuyet') {

      newState = {
        ...newState,
        truongPhongChiDinh: '',
        canBoChiDinh: ''
      }
    }

    this.setState({
      ...newState
    }, this.trigger(newState));
  }

  trigger(newState) {

    if (newState.nextState) {

      let stateId = this.props.getState(this.props.listNextStates, newState.nextState);

      let paramsPatch = this.state.dataGiaiQuyetDon;
      let paramsPost = {};

      paramsPatch.nextState = {
        id: Number(stateId),
        type: newState.nextState
      }

      paramsPost.nextState = {
        id: Number(stateId),
        type: newState.nextState
      }

      paramsPost.thongTinGiaiQuyetDon = {
        id: this.props.thongTinGiaiQuyetDonId
      }

      let params = {
        paramsPatch: paramsPatch,
        paramsPost: paramsPost,
        notice : msg.thuHoiDon
      }
      this.props.onChange(params);
    }
  }

  render() {
    return (
      <div className="pt-dialog-body">
        <p className="reception-dialog-text">{this.state.content}</p>
      </div>
    );
  }
}

ThuHoiGQ.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  }
}

function bindStateToProps(state) {
  return {
    dataThongTinXuLyGiaiQuyet: state.formDataTiepCongDan.thongTinXuLyGiaiQuyet
  }
}

export default connect(bindStateToProps)(validatable(ThuHoiGQ));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/thu-hoi-form/ThuHoiGQ.jsx